import styled, { css } from 'styled-components'

interface ButtonProps {
	active?: boolean
}

export const FilterChip = styled.button<ButtonProps>`
	font-family: ${({ theme }) => theme.fonts.fontFamily};
	color: ${({ theme }) => theme.colors.textDark};
	border-radius: 5rem;
	font-size: 1.6rem;
	font-weight: bold;
	line-height: 130%;
	white-space: nowrap;
	margin: 0 0.5rem;
	padding: 1rem 1.5rem;

	${({ active }) =>
		active &&
		css`
			background-color: ${({ theme }) => theme.colors.primary};
			color: ${({ theme }) => theme.colors.white};
		`}
`
